<template>
	<div class="container">
		<div class="div" v-if="favorites_list && favorites_list.length">
			<div class="div goods-item"  v-for="(item, index) in favorites_list" v-bind:key="index"  @click="goDetail(item.goods_id)">
				<div class="goods-info">
					<div class="div p-img">
						<img class="img collection-img" v-bind:src="item.goods_image_url"/>
					</div>
					<div class="div p-info">
						<div class="p-name">{{ item.goods_name }}</div>
						<div class="price-wrapper">
							<div class="p-price">${{ item.goods_price}}</div>
							<span class="p-del" @click.stop="delFavoriteGoods(item.fav_id)">取消收藏</span>
						</div>
					</div>
				</div>
			</div>
		</div>
		<empty-record v-else-if="favorites_list && !favorites_list.length"></empty-record>
	</div>
</template>
<script>
import { Toast, Indicator, MessageBox } from 'mint-ui'
import EmptyRecord from '../../../components/EmptyRecord'
import { getFavoriteGoodsList, delFavoriteGoods } from '../../../api/memberFavorite'
import flexLine from '../../flexLine'
export default {
  components:{
    flexLine,
    EmptyRecord
  },
  name: 'MemberFavoriteGoods',
  data () {
    return {
      favorites_list: false
    }
  },
  created: function () {
    this.getFavoriteGoodsList()
  },

  methods: {
	delFavoriteGoods (favId) {
	  MessageBox.confirm('是否要取消收藏此商品？').then(action => {
		delFavoriteGoods(favId).then(res => {
			if (res) {
			  this.getFavoriteGoodsList()
			}
		}).catch(function (error) {
		  Toast(error.message)
		})
	  })
	},
    getFavoriteGoodsList () {
      Indicator.open()
      getFavoriteGoodsList(this.page, {}).then(res => {
        Indicator.close()
        this.favorites_list = res.result.favorites_list
      }).catch(function (error) {
        Indicator.close()
        Toast(error.message)
      })
    },
	goDetail (goods_id) {
	  this.$router.push({ 'name': 'HomeGoodsdetail', 'query': { 'goods_id': goods_id } })
	}
  }
}
</script>
<style lang="scss" scoped>
.goods-item{background: #fff;padding:.3rem $pageSpace;box-sizing: border-box;}
.goods-item .goods-info{box-shadow: 0px 2px 4px 0px rgba(0,0,0,0.06);display: flex;}
.goods-item .goods-info .p-img{width: 4rem;height: 4rem;}
.goods-item .goods-info .p-img .img{width: 4rem;height: 4rem;border-radius: .5rem;}
.goods-item .goods-info .p-info{margin:0 .6rem;width: 60%;display: flex;flex-wrap: wrap;padding: .3rem 0;box-sizing: border-box;align-items: center;}
.goods-item .goods-info .p-info .p-name{color: #333;width: 100%;font-size: .7rem; line-height: .8rem;height: 1.6rem;overflow: hidden;display: -webkit-box; -webkit-box-orient: vertical;-webkit-line-clamp: 2;box-sizing: border-box;}
.goods-item .goods-info .p-info .price-wrapper{display: flex;align-items: end;width: 100%;}
.goods-item .goods-info .p-info .price-wrapper .p-price{color: $primaryColor;}
.goods-item .goods-info .p-info .price-wrapper .p-del{margin-left: auto;display: flex;font-size: .6rem;color: #fff;background: $primaryColor;padding: .2rem .3rem;border-radius: .5rem;}
</style>